import { useLocation, useNavigate } from "react-router-dom";
import { FaBook, FaDollarSign, FaFileExport } from "react-icons/fa";
import styles from "./navbar.module.css";
import { useEffect, useState } from "react";
import { fetchBoardName } from "../../redux/reducers/trello/slice";
import { useDispatch, useSelector } from "react-redux";

export function NavBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isActive, setIsActive] = useState(location.pathname);
  const { boardName } = useSelector((state) => state.trello);
  
  useEffect(() => {
    setIsActive(location.pathname);
  }, [location]);

  useEffect(() => {
    if (!boardName) dispatch(fetchBoardName());
    // eslint-disable-next-line
  }, []);

  const routes = [
    {
      name: "Export",
      route: "/export",
      visible: true,
      icon: <FaFileExport className={styles.navLinkIcon} />,
    },
    {
      name: "Billing",
      route: "/billing",
      visible: true,
      icon: <FaDollarSign className={styles.navLinkIcon} />,
    },
    {
      name: "Instructions",
      route: "/instructions",
      visible: true,
      icon: <FaBook className={styles.navLinkIcon} />,
    },
  ];

  const handleGoToPage = (page) => {
    navigate(page);
    setIsActive(page);
  };

  return (
    <nav className={styles.navbar}>
      {routes.map((r) =>
        r.visible ? (
          <div key={r.route} className={styles.navItem}>
            <div
              onClick={() => handleGoToPage(r.route)}
              className={`${styles.navLink} ${
                isActive === r.route ? styles.navLinkActive : ""
              }`}
            >
              {r.icon} {r.name}
            </div>
          </div>
        ) : null
      )}
    </nav>
  );
}

export default NavBar;
